import { buildLaunchUrl, launchPcApp, removeQueryKeys } from '~/utils/launchApp'
import type { LaunchAppParams } from '~/utils/launchApp'

// 唤起所需的 query 参数名，四个必须全部存在才唤起
const REQUIRED_KEYS: (keyof LaunchAppParams)[] = ['app', 'action', 'resourcecode', 'env']

// 允许唤起的 app 白名单（默认拒绝），防止 app 被构造成任意/危险协议头
const ALLOWED_APPS = [
  'fe-develop',
  'clstudio',
  'clstudio-rct',
  'clstudio-beta',
  'clstudio-patchfe',
  'clstudio-develop',
  'clstudio-mct',
  'clstudio-dev'
]

/**
 * 进站时读取 URL query 参数，尝试唤起 PC 客户端。
 * - 仅客户端执行（.client 后缀）、应用启动时执行一次
 * - 四个参数齐全时才唤起，缺任一则跳过
 * - 唤起失败/未安装/用户取消均不做处理，页面保持原样
 */
export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute()
  const query = route.query

  // query 值可能是 string | null | 数组，统一取为字符串
  const getValue = (key: string): string => {
    const value = query[key]
    if (Array.isArray(value)) return value[0] ?? ''
    return value ?? ''
  }

  // 校验并收集四个参数，缺任一则直接放弃唤起
  const params = {} as LaunchAppParams
  for (const key of REQUIRED_KEYS) {
    const value = getValue(key)
    if (!value) return
    params[key] = value
  }

  // app 不在白名单则视为非法，不唤起、不清理，页面保持原样
  if (!ALLOWED_APPS.includes(params.app)) return

  launchPcApp(buildLaunchUrl(params))

  // 清除地址栏的这四个参数（不刷新、保留其它 query）。
  // 延迟到应用挂载完成后执行，避免被路由初始化时的 URL 同步覆盖。
  nuxtApp.hook('app:mounted', () => {
    removeQueryKeys(REQUIRED_KEYS)
  })
})
